import { render } from "./CtqByLevel.vue?vue&type=template&id=659a4bb9&scoped=true"
import script from "./CtqByLevel.js?vue&type=script&lang=js"
export * from "./CtqByLevel.js?vue&type=script&lang=js"

import "./CtqByLevel.vue?vue&type=style&index=0&id=659a4bb9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-659a4bb9"]])

export default __exports__